"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppManifestLoader = useAppManifestLoader;
const feature_flags_1 = require("@juvare/common-js/feature-flags");
const featureFlagsHolderObject_1 = require("@juvare/common-js/feature-flags/featureFlagsHolderObject");
const hooks_1 = require("@juvare/common-web-ui/hooks");
const utils_1 = require("@juvare/common-web-ui/utils");
const usePublicDataClient_1 = require("../../ui/hooks/usePublicDataClient");
const lodash_isequal_1 = __importDefault(require("lodash.isequal"));
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const stores_1 = require("../stores");
const usePreloader_1 = require("./usePreloader");
function useAppManifestLoader(params) {
    const state = (0, react_redux_1.useSelector)(getAppManifest);
    const dispatch = (0, react_redux_1.useDispatch)();
    const publicDataClient = (0, usePublicDataClient_1.usePublicDataClient)();
    const onFeatureFlagConfigChange = (0, hooks_1.useFeatureFlagConfigChange)();
    const { status, onReload } = (0, usePreloader_1.usePreloader)({
        status: state?.status ?? 'initial',
        onLoad: () => {
            dispatch(stores_1.appManifestSlice.actions.setLoading());
            return publicDataClient.publicDataGetAppManifest();
        },
        onSuccess: (result) => {
            (0, feature_flags_1.initFeatureFlags)({ config: result.featureFlags });
            onFeatureFlagConfigChange();
            dispatch(stores_1.appManifestSlice.actions.setAppManifest(result));
        },
        onError: (error) => {
            dispatch(stores_1.appManifestSlice.actions.setError((0, utils_1.getErrorMessage)(error)));
        },
    });
    react_1.default.useEffect(() => {
        let timeoutHandle;
        const autoRefreshSeconds = params?.autoRefreshSeconds;
        if (autoRefreshSeconds != null) {
            const autoRefresh = () => {
                publicDataClient
                    .publicDataGetAppManifest()
                    .then((result) => {
                    if ((0, lodash_isequal_1.default)(result.featureFlags, featureFlagsHolderObject_1.featureFlagsHolderObject.config)) {
                        (0, feature_flags_1.initFeatureFlags)({ config: result.featureFlags });
                        onFeatureFlagConfigChange();
                    }
                    dispatch(stores_1.appManifestSlice.actions.updateAppManifest(result));
                })
                    .catch((error) => {
                    console.error('Failed to refresh app manifest', error);
                })
                    .finally(() => {
                    timeoutHandle = window.setTimeout(autoRefresh, autoRefreshSeconds * 1000);
                });
            };
            timeoutHandle = window.setTimeout(autoRefresh, autoRefreshSeconds * 1000);
        }
        return () => {
            if (timeoutHandle != null) {
                window.clearTimeout(timeoutHandle);
            }
        };
    }, [params?.autoRefreshSeconds]);
    return {
        status: status === 'error' ? 'done' : status,
        onReload,
    };
}
function getAppManifest(state) {
    return state.appManifest.appManifest;
}
